/** @jsxImportSource @emotion/react */
import React from "react";
import { GlobalStore } from "../../store/global/GlobalStore";
import equal from "../../img/trade-interface/equal.svg";
import { isManyToOne } from "../../utils/quoteUtils";
import { Amount } from "../../types/amount";
import { ratesInfo } from "../../config/commonCSS";

export const BeforeNetworkFeeRow: React.FC = () => {
  const theme = GlobalStore.useState(s => s.theme);
  const network = GlobalStore.useState(s => s.network);
  const makerTokens = GlobalStore.useState(s => s.makerTokens);
  const quote = GlobalStore.useState(s => s.quote);
  const getBeforeNetworkFee = (): Amount => {
    if (quote) {
      if (isManyToOne(quote)) {
        const token = Object.values(quote.makerTokens)[0];
        const amountBeforeFee: Amount = token.amountBeforeFee ?? Amount.ZERO;
        return amountBeforeFee;
      }
    }
    return Amount.ZERO;
  };

  return (
    <>
      <hr className="dashed my-1" />
      <div
        className="d-flex justify-content-between align-items-center"
        data-testid="before-network-fee-row"
      >
        <div
          className="d-flex align-items-center m-0 text-secondary"
          style={{ color: theme.font.secondary.default }}
        >
          <img src={equal} className="pe-2" alt={"Network fee"} />
          Before {network.name} Fee
        </div>
        <>
          <div className="d-flex flex-column align-items-end">
            {makerTokens.length <= 1 && (
              <span css={ratesInfo}>
                {getBeforeNetworkFee().value.toDP(5).toString()}{" "}
                {quote && isManyToOne(quote) ? makerTokens[0].token : ""}
              </span>
            )}
          </div>
        </>
      </div>
    </>
  );
};
